module.exports = __webpack_public_path__ + "img/CCM.2b3aa25e.jpg";